import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Fade, Backdrop, Button } from '@material-ui/core';
import alertingAppIcon from 'url:../assets/neuralert_app_icon.png';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
    marginBottom: 12,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    width: '375px',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  icon: {
    width: 56,
    height: 56,
    marginBottom: 12,
    objectFit: 'contain',
  },
  button: {
    marginTop: 16,
    width: '30%',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const AlertingAppReminderModal = ({ open, onClose }) => {
  const classes = useStyles();
  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Modal
      aria-labelledby="alerting-app-reminder-title"
      aria-describedby="alerting-app-reminder-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <img className={classes.icon} src={alertingAppIcon} alt="Neuralert app icon" />
          <h2 id="alerting-app-reminder-title" className={classes.title}>
            Please log into the alerting app
          </h2>
          <p id="alerting-app-reminder-description">
            Patient association is complete. Sign into the alerting app so you can receive alerts.
          </p>
          <Button className={classes.button} size="small" variant="contained" onClick={onClose}>
            Continue
          </Button>
        </div>
      </Fade>
    </Modal>
  );
};

AlertingAppReminderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AlertingAppReminderModal;
